import React, { useEffect, useState } from 'react';
import successIcon from '../../Images/Common/success-icon.svg';
import './style.scss';
import axios from 'axios';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Spin, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
// import { projects } from '../../../../../shared-lib/src/config';

const baseUrl = 'https://api-nimbus.flixstock.com/';
const distributorId = '663b39b3ab4ec46c6ebcf259';
const token = localStorage.getItem('metamodel_token');

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getDetails = async () => {
    const purchaseInfo = searchParams.get('purchaseInfo');
    if (!purchaseInfo) return;

    try {
      const response = await axios.get(
        `${baseUrl}api/v1/pricing/checkout/info/${purchaseInfo}`,
        {
          headers: {
            authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            distributorId,
          },
        }
      );
      setDetails(response?.data?.data);
    } catch (error) {
      console.log(error);
      message.error(error.message);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  useEffect(() => {
    const txnMetadata = searchParams.get('txnMetadata');
    if (txnMetadata && details) {
      const value = JSON.parse(txnMetadata);
      if (value.redirectby === 'generate') {
        setTimeout(() => {
          navigate('/generate');
        }, 3000);
      }
    }
  }, [details, location, searchParams, navigate]);

  const handleDownload = () => {
    setLoading(true);
    const url = details?.invoiceInfo?.invoice_pdf;
    if (url) {
      setTimeout(() => {
        setLoading(false);
        window.location.href = url;
      }, 1000);
    } else {
      navigate('/');
    }
  };

  const formatBillingHistoryDate = (isoString) => {
    const date = new Date(isoString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}, ${date.toLocaleTimeString()}`;
  };

  const currencySymbol = (currency) => {
    switch (currency?.toLowerCase()) {
      case 'usd':
      case 'sgd':
        return '$';
      case 'inr':
        return '₹';
      default:
        return currency || '';
    }
  };

  return (
    <div className="payment_success_details">
      <div className="success_card">
        <img src={successIcon} alt="Success Icon" className="success_icon" />
        <div className="payment_status">
          <h2 className="status_title">Payment Success!</h2>
          <p className="price">
            {currencySymbol(details?.plan?.currency)}
            {details?.plan?.value}
          </p>
        </div>
        <div className="other_details">
          <div className="details_box">
            <div className="column">
              Ref Number<span>{searchParams.get('purchaseInfo')}</span>
            </div>
            <div className="column">
              Payment Time
              <span>{formatBillingHistoryDate(details?.createdAt)}</span>
            </div>
            <div className="column">
              Sender Name
              <span>{details?.invoiceInfo?.customer_name || '-'}</span>
            </div>
          </div>
          <div className="amount_details">
            <div className="column">
              Amount
              <span>
                {currencySymbol(details?.plan?.currency)}
                {details?.plan?.value}
              </span>
            </div>
          </div>
        </div>
        <button className="download_invoice" onClick={handleDownload}>
          {details?.invoiceInfo?.invoice_pdf
            ? 'Download Invoice'
            : 'Go to Dashboard'}
          {loading && (
            <Spin
              indicator={
                <LoadingOutlined
                  style={{ fontSize: 14, color: 'white', marginLeft: 8 }}
                  spin
                />
              }
            />
          )}
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
